import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Brand fonts, self-hosted. Family strings must match the token stacks:
// 'Young Serif' (display, 400 only), 'Instrument Sans Variable' (UI),
// 'IBM Plex Mono' (chords/lyrics — full subsets, lyrics are user content).
import '@fontsource/young-serif';
import '@fontsource-variable/instrument-sans';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource/ibm-plex-mono/600.css';

import '@chordbookpro/design-tokens/tokens.css';
import './styles/global.css';

import { App } from './App.jsx';
import { QueryProvider } from './providers/QueryProvider.jsx';
import { AuthProvider } from './providers/AuthProvider.jsx';
import { SubscriptionProvider } from './providers/SubscriptionProvider.jsx';
import { ErrorBoundary } from './components/feedback/ErrorBoundary.jsx';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <QueryProvider>
          <AuthProvider>
            <SubscriptionProvider>
              <App />
            </SubscriptionProvider>
          </AuthProvider>
        </QueryProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
